import { format, isValid, parseISO } from "date-fns"

// Display-only формат модуля материалов (не переносится в core utils/date).
export const formatContentDateTime = (
  value: string | null | undefined,
): string => {
  if (!value) {
    return "—"
  }
  const parsed = parseISO(value)
  if (!isValid(parsed)) {
    return "—"
  }
  return format(parsed, "dd.MM.yyyy HH:mm")
}
